import { SxProps, Theme } from '@mui/material/styles';

export const SX_MENU_ITEM: SxProps<Theme> = {
  '&:last-child a:after': {
    display: 'none',
  },
  display: 'list-item',

  padding: 0,
};

export const SX_ROUTE: SxProps<Theme> = {
  '&:after': {
    backgroundColor: '#edc66754',
    bottom: '-2px',
    content: '""',
    height: '1px',
    left: '0',
    position: 'absolute',
    transform: 'scaleX(1)',
    visibility: 'visible',
    width: '100%',
  },
  color: '#fff',
  display: 'block',
  fontWeight: '600',
  letterSpacing: '2px',
  lineHeight: '40px',
  margin: '0.5rem 1.25rem',
  textAlign: 'center',
  textTransform: 'uppercase',
};
